import { Injectable } from '@angular/core';

/**
 * Primeira mensagem do "Editar com IA" vinda de fora do editor.
 *
 * O wizard "Criar com IA" cria o documento e abre o editor no modo IA; a descrição que a
 * pessoa escreveu no wizard vira a primeira mensagem do chat, enviada pelo painel da IA
 * assim que ele abre NAQUELE documento. Vale uma vez: quem consome apaga.
 */
@Injectable({ providedIn: 'root' })
export class AiEditKickoffService {
    private _pending: { documentId: string; text: string } | null = null;

    /** Guarda a mensagem para o documento. Texto vazio não agenda nada. */
    public queue(documentId: string, text: string): void {
        const message = text?.trim();
        this._pending = documentId && message ? { documentId, text: message } : null;
    }

    /** A mensagem agendada para este documento, sem consumir. */
    public peek(documentId: string | undefined): string | null {
        return documentId && this._pending?.documentId === documentId ? this._pending.text : null;
    }

    /** Consome a mensagem agendada para este documento (`null` se não houver). */
    public take(documentId: string | undefined): string | null {
        const text = this.peek(documentId);
        if (text) this._pending = null;
        return text;
    }

    public clear(): void {
        this._pending = null;
    }
}
